// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"6e3ae5df","239":"2f822dd7","433":"44865f00","455":"ca27586a","749":"168afddd","851":"3815ed90","903":"6315f363","959":"3c42f0e2","977":"c7d6623c"}[chunkId] + ".chunk.js";
};